import { defineComponent as _defineComponent } from 'vue'
import Navigation from "../../../NavigationContainer.vue"
import { ref, onMounted, reactive, onUpdated } from "vue"
import Alert from "@/components/scan/parts/Alert.vue"
import SalesNoteLinkNavigation from "../../../KDPSalesNoteLinkNavigationContainer.vue"
import SalesNoteHeaderNavigation from "../../../KDPSalesNoteHeaderNavigationContainer.vue"
import Loading from "@/components/home/Loading.vue"
import KDPConfimrSalesNoteDataService from "@/services/KDPConfirmSalesNoteDataService"
import { useI18n } from "vue3-i18n"
import ResponseData from "@/types/ResponseData"
import { store } from "@/store/store"
import { useRouter } from "vue-router"
import KDPSalesNote from "@/types/KDPSalesNote"


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const isLoading = ref(false)
const alertMessage = ref("null")
const alertState = ref("neutral")
const i18n = useI18n()
const router = useRouter();
const confirmSalesNoteInfoList = reactive([]);
const btnChkSNFlg = ref(true);
const btnSelectAllFlg = ref(false);
const btnClearAllFlg = ref(true);
const paramSalesNote = reactive([]);
const statusData = reactive({distributorName: "",scan_kdp_approval:[]});
const menuCD = ref("");

/** 初期設定 */
onMounted(function () {
  isLoading.value = true;
  menuCD.value = store.getters.mainMenuCode;

  selectConfirmSalesNoteInfoList()
})

/** 一覧の表示データ取得 */
const selectConfirmSalesNoteInfoList = () => {
  isLoading.value = true;
  confirmSalesNoteInfoList.splice(0);

  // 二回目実行にアラートメッセージが表示修正
  alertMessage.value = "null";
  alertState.value = "neutral";
  
  const data = {
    userId: store.getters.cognitoUserName,
    menuCD : menuCD.value
  };
  KDPConfimrSalesNoteDataService.selectKDPConfirmSalesNote(data)
    .then((response: ResponseData) => {
      if (response.data.length != 0) {
        confirmSalesNoteInfoList.push(...response.data);

        // # CountryCode取得
        var parentCDList = [...new Set(
          confirmSalesNoteInfoList.map((item : any) => item.parentDistributorCode)
        )];

        const lambdadData = {
          functionName: "selectKDPConfirmSalesNote",
          parentCDList : parentCDList
        }
        KDPConfimrSalesNoteDataService.selectKDPConfirmSalesNote_v2(lambdadData)
          .then((res: ResponseData) => {
            if (res.data.length != 0) {
              const snListForV2 = new Map(
                res.data.data.map((item : any) => [item.parent_cd, item])
              )
              
              for (const info of confirmSalesNoteInfoList) {
                info.szcntreab_nm = (snListForV2.get(info.parentDistributorCode) as any).szcntreab_nm
                info.agn_name = (snListForV2.get(info.parentDistributorCode) as any).agn_name
              }
            }
            isLoading.value = false;
          })
          .catch((error: ResponseData) => {
            btnSelectAllFlg.value = true
            alertMessage.value = i18n.t("err111");
            alertState.value = "error";
            isLoading.value = false;
          });

        // SelectAllボタン無効の状況チェック
        if (confirmSalesNoteInfoList.every((row : any) => row.isChkEnabled === true)) {
          btnSelectAllFlg.value = true
        }
      } else {
        btnSelectAllFlg.value = true
        isLoading.value = false;
      }
    })
    .catch((error: ResponseData) => {
      btnSelectAllFlg.value = true
      alertMessage.value = i18n.t("err111");
      alertState.value = "error";
      isLoading.value = false;
    });
}

/** SelectAllボタンクリックイベント */
const selectAll = () => {
  var chkCount = 0
  for (let info of confirmSalesNoteInfoList) {
    if (!info.isChkEnabled) {
      info.isChecked = true
      chkCount += 1
    }
  }
  if (chkCount != 0) {
    btnChkSNFlg.value = false
    btnSelectAllFlg.value = true
    btnClearAllFlg.value = false
  }
};

/** ClearAllボタンクリックイベント */
const clearAll = () => { 
  for (let info of confirmSalesNoteInfoList) {
    info.isChecked = false
  }
  btnChkSNFlg.value = true
  btnSelectAllFlg.value = false
  btnClearAllFlg.value = true
};

/** 一覧のチェックボックスクリックイベント */
const chkCheckEvent = (info : any) => {
  if (info.isChecked) {
    info.isChecked = false
  } else {
    info.isChecked = true
  }

  var checkedList = confirmSalesNoteInfoList.every((i: { isChecked: boolean; }) => i.isChecked === false)
  if (checkedList) {
    // All Uncheck
    btnChkSNFlg.value = true
    btnSelectAllFlg.value = false
    btnClearAllFlg.value = true
  } else {
    btnChkSNFlg.value = false
    btnSelectAllFlg.value = false
    btnClearAllFlg.value = false

    // 無効のチェックボックスを外す
    var checkableList = confirmSalesNoteInfoList.filter((i: { isChkEnabled: boolean; }) => i.isChkEnabled === false)
    if (checkableList.length > 0) {
      var allCheckFlg = checkableList.every((i: { isChecked: boolean; }) => i.isChecked === true)
      if (allCheckFlg) {
        btnSelectAllFlg.value = true
        btnClearAllFlg.value = false
      }
    }
  }
}

/** 一覧のstatsuリンククリックイベント */
const showModal = (info : any) => {
  statusData.distributorName = "";
  statusData.scan_kdp_approval = [];
  isLoading.value = true; 
  const dataLambda = { 
    functionName : "getDistributorName",
    distCd : info.parentDistributorCode 
  };
  KDPConfimrSalesNoteDataService.getDistributorName(dataLambda)
  .then((response) => {
    statusData.distributorName = response.data.distributor_name;
    const data = { 
      saleNo : info.salesNo,
      seqNo : info.seqNo,
      userId : store.getters.cognitoUserName
    };
    KDPConfimrSalesNoteDataService.getStatusDetail(data)
    .then((response: ResponseData) => {
      if (response.data.length !== 0) {
        statusData.scan_kdp_approval = response.data.scan_kdp_approval;
        isLoading.value = false; 
      }
    })
    .catch((error: ResponseData) => {
      alertMessage.value = i18n.t("err117");
      alertState.value = "error";
      isLoading.value = false; 
    });
  })
  .catch((error: ResponseData) => {
    alertMessage.value = i18n.t("err109");
    alertState.value = "error";
    isLoading.value = false; 
  });
}

/** 一覧のpdfアイコン表示イベント */
const showPDFFile = (info : any) => {
  var subFolderPDF = info.pdfCreatedYM + "_" + info.salesNo + "_" + info.parentDistributorCode + "_" + info.distributorCode + "_" + info.seqNo
  var pdfFileName = subFolderPDF + "/" + info.salesNo + ".pdf"

  isLoading.value = true;
  const data = { 
    'fileName' : pdfFileName,
    'userId' : store.getters.cognitoUserName
  }

  KDPConfimrSalesNoteDataService.getPreSignedUrl(data)
    .then((response: ResponseData) => {
      if (response.data == '') {
        alert(i18n.t("alt110"))
      } else {
        window.open(response.data)?.focus()
      }
      isLoading.value = false
    })
}

/** checkSalesNoteボタンクリックイベント */
const checkSalesNote = () => {
    var checkedList
    checkedList = confirmSalesNoteInfoList.filter((i: { isChecked: boolean; }) => i.isChecked === true)
    if (checkedList.length == 0) {
      alert(i18n.t("alt102"))
      return
    }
    sendParam(checkedList)
    store.dispatch("setKDPSalesNoteScreen", 'KDPConfirmSalesNote')

    if (store.getters.stationCode == '1000') {
      router.push('/KDPTermsofService')
    } else {
      router.push('/ShowPDFFileByKDPSalesNote')
    }
}

/** 次の画面で使うためstoreにパラメータの保存 */
const sendParam = (checkedList : any) => {
  paramSalesNote.splice(0)
  var salesNoteInfo : KDPSalesNote

  for (let param of checkedList) {
    salesNoteInfo = {
      salesNo : param.salesNo,
      prodYM : param.productionYM,
      seqNo : param.seqNo,
      parentCD : param.parentDistributorCode,
      distCD : param.distributorCode,
      factory : param.factory,
      status : param.status,
      statusDescription : param.description,
      pdfFlg : param.pdfFlg,
      pdfCreatedYM: param.pdfCreatedYM
    }
    paramSalesNote.push(salesNoteInfo)
  }
  
  store.dispatch("setParamKDPSalesNoteList", paramSalesNote)
}

onUpdated(function () {
  try {
    var dataHeight = document.getElementById("tbltbody")?.clientHeight;
    if (dataHeight != 0) {
      var tableHeight = document.getElementById("tblbodydiv")?.clientHeight;
      if (dataHeight > tableHeight) {
        document.getElementById("tblbodydiv").style.width = "100%";
        document.getElementById("tblbodydiv").style.borderBottom = "#ccc solid 0.5px";
      } else {
        document.getElementById("tblbodydiv").style.width = "calc(100% - 16px)";
      }
    }
  } catch (e) {
    isLoading.value = false;
  }
})

const __returned__ = { isLoading, alertMessage, alertState, i18n, router, confirmSalesNoteInfoList, btnChkSNFlg, btnSelectAllFlg, btnClearAllFlg, paramSalesNote, statusData, menuCD, selectConfirmSalesNoteInfoList, selectAll, clearAll, chkCheckEvent, showModal, showPDFFile, checkSalesNote, sendParam, Navigation, Alert, SalesNoteLinkNavigation, SalesNoteHeaderNavigation, Loading }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})